export enum SearchMode {
  TEXT,
  TOPICS
}
